import { render, staticRenderFns } from "./AreaIncomeReport.vue?vue&type=template&id=3936b16e&lang=pug&"
import script from "./AreaIncomeReport.vue?vue&type=script&lang=ts&"
export * from "./AreaIncomeReport.vue?vue&type=script&lang=ts&"
import style0 from "./AreaIncomeReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports